import { MultiAdapter } from "./adapters/multi.adapter";
import { getAnalyticsConfig } from "./config";
import { NoopAdapter } from "./noop.adapter";
import { createAdaptersForProviders } from "./registry";
import type { AnalyticsAdapter } from "./types";

let cachedAdapter: AnalyticsAdapter | null = null;

export function getAnalyticsAdapter(): AnalyticsAdapter {
  if (cachedAdapter) return cachedAdapter;
  
  // Get validated provider keys from config
  const providerKeys = getAnalyticsConfig();
  
  // Create adapters for the configured providers
  const adapters = createAdaptersForProviders(providerKeys);

  // If no valid adapters found, use NoopAdapter
  if (adapters.length === 0) {
    cachedAdapter = new NoopAdapter();
  } else if (adapters.length === 1) {
    // Single adapter - use it directly
    cachedAdapter = adapters[0]!;
  } else {
    // Multiple adapters - wrap in MultiAdapter
    cachedAdapter = new MultiAdapter(adapters);
  }

  // Initialize the adapter - both sync and async init methods are handled
  const initResult = cachedAdapter.init();
  if (initResult instanceof Promise) {
    void initResult; // Fire and forget for async initialization
  }
  
  return cachedAdapter;
}


